export const GET_CHARGEBACK_STATUS_DEF = "GET_CHARGEBACK_STATUS_DEF"
export const GET_CHARGEBACK_STATUS_DEF_SUCCESS = "GET_CHARGEBACK_STATUS_DEF_SUCCESS"
export const GET_CHARGEBACK_STATUS_DEF_FAIL = "GET_CHARGEBACK_STATUS_DEF_FAIL"

export const CHARGEBACK_STATUS_DEF_API_ERROR = "API_ERROR"